<!-- 有偿投稿视频 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">有偿投稿{{ typeMap[type] }}</p>
		</div>

		<div class="box">
<!--      <div v-html="config.customer_service"></div>-->
			<img :src="config.service_qr_code" class="code-img">
			<span class="msg">电话：{{ config.service_phone }}</span>
			<span class="msg">邮箱：{{ config.service_email }}</span>
<!--			<button type="button" class="btn" @click="copyPhone(config.service_phone)">联系我们</button>-->
		</div>

	</div>
</template>

<script>
	import {ExpediteService} from "@/common/service";
  import {copy} from "@/common/util";
  import {Toast} from "vant";

  export default {
		components: {},
		data() {
			return {
        // 搜索类型 1 视频 2 图文 3 资料
        type: 1,
        typeMap: {
          1: '视频',
          2: '图文',
          3: '资料',
        },
        config: {},
			};
		},
		mounted() {
      const option = this.$route.query;
      this.type = parseInt(option.type || 1);
      this.getSysConfig();
    },
		methods: {
      getSysConfig() {
        ExpediteService.getServiceSet().then(({data}) => {
          this.config = data;
        });
      },
      copyPhone(phone) {
        // copy(phone);
        // Toast('已复制电话到粘贴板');
      }
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background-color: #F4F4F4;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 74px 37px 37px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #FFFFFF;
		box-shadow: 0 0 14px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		padding: 40px 0 16px;
		box-sizing: border-box;
		margin-bottom: 30px;
	}

	.code-img {
		width: 200px;
		height: 200px;
		margin-bottom: 10px;
	}

	.msg {
		color: #666666;
		font-size: 14px;
		margin-bottom: 2px;
	}

	.btn {
		color: #FFFFFF;
		font-size: 16px;
		background-color: #2A63F3;
		border-radius: 100px;
		width: 155px;
		height: 38px;
		line-height: 38px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 10px;
	}
</style>
